import { render, staticRenderFns } from "./ContactCreatedSuccess.vue?vue&type=template&id=c9b33c02&"
import script from "./ContactCreatedSuccess.vue?vue&type=script&lang=js&"
export * from "./ContactCreatedSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports